import { ActionName, ActionProcessMode, tg } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import {
  executePrintAction,
  ExecutePrintActionReturn,
} from '../../common/executePrintAction';
import { ClientContext } from '../../context/IContextService';
import {
  ConfirmationMessageType,
  UserInteractor,
  UserInteractorType,
} from '../UserInteractor';

import RunActionCommandImpl from './RunActionCommandImpl';

class PrintCommandImpl extends RunActionCommandImpl {
  public async execute(
    context: ClientContext,
    args: TActionArgsValues
  ): Promise<ExecutePrintActionReturn> {
    return executePrintAction(this.action, context, args, this.actionSchema);
  }

  public getName(): ActionName {
    return this.action;
  }

  public getUserInteractor(): UserInteractor {
    if (tg.isActionWithForm(this.actionSchema)) {
      return {
        type: UserInteractorType.PRINT_FORM,
        category: this.category,
        action: this.action,
      };
    }
    if (tg.isActionWithConfirmationOptions(this.actionSchema)) {
      return {
        type: UserInteractorType.CONFIRMATION,
        message: ConfirmationMessageType.PRINT,
      };
    }
    if (tg.isPrintAction(this.actionSchema)) {
      return tg.isServerPrintAction(this.actionSchema)
        ? {
            type: UserInteractorType.NONE,
          }
        : {
            type: UserInteractorType.PRINT_FORM_ON_CLIENT,
            templateName: this.actionSchema.TemplateCode,
          };
    }
    throw new Error('Action schema does not match print interactor type');
  }

  public getProcessMode(): ActionProcessMode {
    return this.actionSchema.ProcessMode;
  }
}

export default PrintCommandImpl;
